import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {RECAPTCHA_V3_SITE_KEY, RecaptchaFormsModule, RecaptchaModule} from 'ng-recaptcha';

import {AccessSecurityCodeComponent} from './pages/access-security-code/access-security-code.component';
import {AccessValidationMessageComponent} from './pages/access-validation-message/access-validation-message.component';
import {ActivateAccessComponent} from './pages/activate-access/activate-access.component';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {AuthHelper} from './helpers/http-interceptor';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {ChangeFirstPasswordComponent} from './pages/change-first-password/change-first-password.component';
// SERVICES
import {ClientService} from './services/client.service';
import {ContractDetailsComponent} from './components/contract-details/contract-details.component';
import { ContractSummaryComponent } from './pages/contract-summary/contract-summary.component';
import {ContractsComponent} from './pages/contracts/contracts.component';
import {CustomPaginatorComponent} from './components/custom-paginator/custom-paginator.component';
import {EnterMailPassComponent} from './pages/enter-mail-pass/enter-mail-pass.component';
// EXTERNAL
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {FooterComponent} from './components/footer/footer.component';
import {ForgotPasswordFormComponent} from './pages/forgot-password-form/forgot-password-form.component';
import {FormComponent} from './components/form/form.component';
import {HistoricContractsComponent} from './components/historic-contracts/historic-contracts.component';
import {HistoricRenovationComponent} from './components/historic-renovation/historic-renovation.component';
// COMPONENTS
import {HomeComponent} from './pages/home/home.component';
import {LoaderComponent} from './components/loader/loader.component';
import {ModalComponent} from './components/modal/modal.component';
import {ModifyDataService} from './services/modify-data.service';
import {NavBarComponent} from './components/nav-bar/nav-bar.component';
import {NewPasswordFormComponent} from './pages/new-password-form/new-password-form.component';
import {NgModule} from '@angular/core';
import {NgxPaginationModule} from 'ngx-pagination';
import {PaymentErrorComponent} from './pages/payment-error/payment-error.component';
import {PaymentSuccessComponent} from './pages/payment-success/payment-success.component';
import {PersonalDataComponent} from './pages/personal-data/personal-data.component';
import {PrivateAreaService} from './services/private-area.service';
import {ReactiveFormsModule} from '@angular/forms';
import {SecurityCodeFormComponent} from './pages/security-code-form/security-code-form.component';
// UTILS
import {environment} from '../environments/environment';
import { ContractPolicyComponent } from './components/contract-policy/contract-policy.component';

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        NavBarComponent,
        FooterComponent,
        FormComponent,
        ContractsComponent,
        ModalComponent,
        LoaderComponent,
        PersonalDataComponent,
        ContractDetailsComponent,
        HistoricRenovationComponent,
        HistoricContractsComponent,
        ForgotPasswordFormComponent,
        SecurityCodeFormComponent,
        NewPasswordFormComponent,
        CustomPaginatorComponent,
        ActivateAccessComponent,
        AccessValidationMessageComponent,
        AccessSecurityCodeComponent,
        PaymentErrorComponent,
        PaymentSuccessComponent,
        EnterMailPassComponent,
        ContractSummaryComponent,
        ChangeFirstPasswordComponent,
        ContractPolicyComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        FontAwesomeModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        NgxPaginationModule,
        RecaptchaModule,
        RecaptchaFormsModule
    ],
    providers: [
        ClientService,
        PrivateAreaService,
        ModifyDataService,
        {provide: RECAPTCHA_V3_SITE_KEY, useValue: `${environment.google_api_key}`},
        AuthHelper,
        {provide: HTTP_INTERCEPTORS, useClass: AuthHelper, multi: true}
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
